import { render } from "./ApprovalSuggestUserTable.vue?vue&type=template&id=21d2c94a&scoped=true"
import script from "./ApprovalSuggestUserTable.vue?vue&type=script&lang=js"
export * from "./ApprovalSuggestUserTable.vue?vue&type=script&lang=js"

import "./ApprovalSuggestUserTable.vue?vue&type=style&index=0&id=21d2c94a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d2c94a"]])

export default __exports__